import moment from "moment";
import "moment/locale/es";

const DATE_FORMAT = "DD/MM/YYYY";

export const formatContractPeriod = (
  start?: string | null,
  end?: string | null
): string | null => {
  if (!start) {
    return null;
  }

  if (!end) {
    return `Desde ${moment(start).format(DATE_FORMAT)}`;
  }

  return `De ${moment(start).format(DATE_FORMAT)} a ${moment(end).format(
    DATE_FORMAT
  )}`;
};
